import * as Scrivito from "scrivito";

const QuoteSliderWidget = Scrivito.provideWidgetClass("QuoteSliderWidget", {
  attributes: {
    dotsDescription: "string",
    quotes: ["referencelist", { only: "Quote" }],
  },
});

export default QuoteSliderWidget;
